import { useState } from 'react'
import { ScrollView, Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// components & screens
import Card from '../../components/shared/card/Card'
import CustomButton from '../../components/shared/button/Button'
import CardSeparator from '../../components/shared/card/CardSeparator'
import TwoColumnDisplay from '../../components/shared/grid/TwoColumnDisplay'
import OneColumnDisplay from '../../components/shared/grid/OneColumnDisplay'
import ModalConfrim from '../../components/shared/modal/ModalConfirm'
import MyScrollView from '../../components/shared/navigator/MyScrollView'

const ConfirmPersonalInfromationScreen = ({ navigation }): JSX.Element => {
  const [modalVisible, setModalVisible] = useState(false)

  const handleConfirmInformation = (): void => {
    setModalVisible(!modalVisible)
  }

  const handleNavigateBackToWelcome = (): void => {
    setModalVisible(!modalVisible)
    navigation.navigate('Home', { status: 'confirmed' })
  }

  const handleEditPersonalInformation = (): void => {
    navigation.navigate('PersonalBasicInformation', {})
  }

  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <TouchableOpacity
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.mb3
            ]}
            onPress={() => {
              navigation.goBack()
            }}
          >
            <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
              <Ionicons
                name="chevron-back"
                size={24}
                color={colorPalette.white}
              />
            </View>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.fs20,
                globalStyles.whiteTextColor,
                globalStyles.ml0
              ]}
            >
              Confirm Personal Information
            </Text>
          </TouchableOpacity>
          <View>
            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              Please confirm that all of your information is correct.
            </Text>
          </View>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs18,
              globalStyles.blackTextColor
            ]}
          >
            Confirm Information
          </Text>
          <CardSeparator />
          <TwoColumnDisplay
            firstTitle="First Name"
            firstDescription="Judith"
            secondTitle="Middle Initial"
            secondDescription="Middle Initial"
            gap={20}
          />
          <TwoColumnDisplay
            firstTitle="Last Name"
            firstDescription="Stephenson"
            secondTitle="SSN"
            secondDescription="XXX - XX - 0012"
            secondVisibility={true}
            gap={20}
          />
          <OneColumnDisplay
            title="Address"
            description="12345 Reallylongname Avenue"
            gap={20}
          />
          <OneColumnDisplay
            title="Suite/Apt Number"
            description="12B"
            gap={20}
          />
          {/* <ThreeColumnDisplay
            firstTitle="City"
            firstDescription="Fredericksburg"
            secondTitle="State"
            secondDescription="VA"
            thirdTitle="Zip Code"
            thirdDescription="12345-0001"
            gap={20}
          /> */}
          <View style={[globalStyles.hDirection]}>
            <View style={[globalStyles.flexOne]}>
              <OneColumnDisplay
                title="City"
                description="Fredericksburg"
                gap={20}
              />
            </View>
            <View style={[globalStyles.hDirection, globalStyles.flexOne]}>
              <View style={{ flex: 0.4 }}>
                <OneColumnDisplay title="State" description="VA" gap={20} />
              </View>
              <View style={{ flex: 0.6 }}>
                <OneColumnDisplay
                  title="Zip Code"
                  description="12345-0001"
                  gap={20}
                />
              </View>
            </View>
          </View>
          <OneColumnDisplay
            title="Date of Birth"
            description="08-08-1967"
            gap={20}
          />
          <TwoColumnDisplay
            firstTitle="Gender"
            firstDescription="Prefer Not to Answer"
            secondTitle="Marital Status"
            secondDescription="Part-time"
          />
          <CardSeparator />
          <OneColumnDisplay
            title="Main Phone Number"
            description="123-456-7890"
            gap={20}
          />
          <OneColumnDisplay
            title="Personal Email Address"
            description="judithmstephenson1967@email.com"
            gap={20}
          />
          <OneColumnDisplay
            title="Emergency Contact Name"
            description="Peter Stephenson"
            gap={20}
          />
          <OneColumnDisplay
            title="Emergency Contact Phone Number"
            description="123-456-7891"
            gap={20}
          />
          <OneColumnDisplay
            title="Emergency Contact Relationship"
            description="Spouse"
          />
        </Card>
        <View style={[globalStyles.mt2, globalStyles.mb4]}>
          <CustomButton
            text={'Submit Information'}
            onPress={handleConfirmInformation}
          />
          <TouchableOpacity onPress={handleEditPersonalInformation}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.textCenter,
                globalStyles.textUnderline,
                globalStyles.secondaryTextColor,
                globalStyles.mt3
              ]}
            >
              Edit Personal Information
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      <ModalConfrim
        title="Success!"
        message="Your Personal Information has been submitted."
        visible={modalVisible}
        setVisible={setModalVisible}
        action={handleNavigateBackToWelcome}
      />
    </MyScrollView>
  )
}

export default ConfirmPersonalInfromationScreen
